import { useEffect } from "react"
import type { ReactNode } from "react"
import { emit, EVENTS, useTelemetry } from "../event-emitter"
import type { TelemetryValue } from "../event-emitter"
import { extractText } from "../utils"

type UseModalTelemetryProps = {
  telemetry?: TelemetryValue
  label?: ReactNode
  ariaLabel?: string
}

/**
 * Emits telemetry when the modal is mounted.
 *
 * @param props - Data to send alongside the event.
 */
export function useModalTelemetry({ telemetry, label, ariaLabel }: UseModalTelemetryProps): void {
  const telemetryPayload = useTelemetry(telemetry)

  useEffect(() => {
    if (telemetryPayload === false) return

    emit(EVENTS.MODAL_OPEN, {
      label: extractText(label),
      ariaLabel: extractText(ariaLabel),
      ...telemetryPayload
    })

    // We're intentionally using an empty dependency array to emit telemetry
    // only once when the modal mounts. This is enforced by a test. Ignoring
    // the warning is intentional and safe.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
